import { render, staticRenderFns } from "./SettingsLogos.vue?vue&type=template&id=5b82725a&scoped=true&"
import script from "./SettingsLogos.vue?vue&type=script&lang=js&"
export * from "./SettingsLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b82725a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b82725a')) {
      api.createRecord('5b82725a', component.options)
    } else {
      api.reload('5b82725a', component.options)
    }
    module.hot.accept("./SettingsLogos.vue?vue&type=template&id=5b82725a&scoped=true&", function () {
      api.rerender('5b82725a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/SettingsLogos.vue"
export default component.exports